import {
  initDatadog,
  isDatadogInitialized,
  setTrackingConsent as setSdkTrackingConsent,
  trackView as startRumView,
} from './sdk';
import type { ObservabilityConfig } from './types';

let lastViewName: string | null = null;

export function initObservability(config: ObservabilityConfig): void {
  if (typeof window === 'undefined') {
    throw new Error(
      'initObservability must be called in the browser — run it from instrumentation-client.ts.'
    );
  }
  if (isDatadogInitialized()) return;

  const { applicationId, clientToken, env } = config;
  // Absent credentials mean observability is intentionally off for this
  // environment — the NEXT_PUBLIC_DATADOG_* vars are only set where sessions
  // should be reported.
  if (!applicationId || !clientToken || !env) return;

  try {
    initDatadog({ ...config, applicationId, clientToken, env });
  } catch (error) {
    // Observability must never break the app it observes, and the SDKs are the
    // reporting channel — the console is the only sink left for this failure.
    console.error('Failed to initialize observability', error);
  }
}

export function setTrackingConsent(granted: boolean): void {
  if (!isDatadogInitialized()) return;
  setSdkTrackingConsent(granted);
  // Views tracked while consent was withheld were discarded by the SDK, and
  // with manual view tracking nothing is collected without an active view —
  // restart the current one so granting consent opens the pipe immediately.
  if (granted && lastViewName !== null) startRumView(lastViewName);
}

export function trackView(name: string): void {
  if (!isDatadogInitialized()) return;
  lastViewName = name;
  startRumView(name);
}
